// REGION REDUCER
const initialState = {
  fetched: false,
  error: null,
  one: {},
  all: [],
  pagination: {}
};
export default function storeReducer(state = initialState, action) {
  switch (action.type) {
    case 'DATA_FILE_GETALL_SUCCESS': {
      return {
        ...state,
        fetched: true,
        all: action.payload.content,
        pagination: {
          last: action.payload.isLast,
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          size: action.payload.size,
          number: action.payload.number,
          first: action.payload.isFirst,
          sort: action.payload.sort,
          numberOfElements: action.payload.numberOfElements
        }
      };
    }
    case 'DATA_FILE_GETONE_SUCCESS': {
      return {
        ...state,
        one: action.payload
      };
    }
    case 'DATA_FILE_CLEAR': {
      return {
        ...state,
        one: initialState.one
      };
    }
  }
  return state;
}
